import { functionsUrl } from "@/plugins/firebase";
import axios from "axios";
import { ref } from "vue";

export const scores = ref<any[]>([]);
export const plays = ref<number>(0);

export const getScores = async () => {
  const response = await axios.get(`${functionsUrl}getScores`);

  scores.value = response.data;
};

export const getPlays = async () => {
  const response = await axios.get(`${functionsUrl}getPlays`);

  plays.value = response.data;
};
